var custom = {
  init: function(){
    custom.fixedHeader();
  	custom.sliderHome();
    custom.menuShi();
    custom.searchExpand();
    custom.sliderCategory();
    custom.countDown();
    custom.sliderGallery();
    custom.mapMarket();
    custom.sidebarStickitCustom();
    custom.quantityNum();
    custom.audioMultiPlayer();
    custom.sliderGallery();
    custom.customSelect();
    custom.centerSlider();
    custom.activeModal();
    custom.validateFormIE();
    custom.tableData();
    custom.anclaPreci();
    custom.hourReserv();
    custom.modalImg();
    custom.addCalendar();
  },
  fixedHeader: function(){
    $('.stickit').stickit();
  },
  sliderHome: function(){
    if($(".slider-home").length){
      $('.slider-home').slick({
        arrows: false,
        dots: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 4000,
        fade: true,
        cssEase: 'linear'
      });
    }
  },
  menuShi: function(){
    if($(".sidenav").length){
      $(".openNav").click(function(e){
        e.preventDefault();
        document.getElementById("shiSidenav").style.width = "360px";
        $("header").addClass("nav-active");
        $("body").addClass("not-scroll");
        $("body").append('<div class="bg-close"></div>');
        closeNav();
      });
      $(".closeNav").click(function(){
        document.getElementById("shiSidenav").style.width = "0";
        $("header").removeClass("nav-active");
        $("body").removeClass("not-scroll");
        $(".bg-close").remove();
      });
    }
    function closeNav(){
      $(".bg-close").click(function(){
        document.getElementById("shiSidenav").style.width = "0";
        $("header").removeClass("nav-active");
        $("body").removeClass("not-scroll");
        $(".bg-close").remove();
      });
    }
  },
  searchExpand: function(){
    function buttonUp(){
      var inputVal = $('.searchbox-input').val();
      inputVal = $.trim(inputVal).length;
      if( inputVal !== 0){
        $('.searchbox-icon').css('display','none');
      } else {
        $('.searchbox-input').val('');
        $('.searchbox-icon').css('display','block');
      }
    }
    var submitIcon = $('.searchbox-icon');
    var inputBox = $('.searchbox-input');
    var searchBox = $('.searchbox');
    var isOpen = false;
    submitIcon.click(function(){
      if(isOpen == false){
        searchBox.addClass('searchbox-open');
        inputBox.focus();
        isOpen = true;
      } else {
        searchBox.removeClass('searchbox-open');
        inputBox.focusout();
        isOpen = false;
      }
    });  
    submitIcon.mouseup(function(){
      return false;
    });
    searchBox.mouseup(function(){
      return false;
    });
    $(document).mouseup(function(){
      if(isOpen == true){
        $('.searchbox-icon').css('display','block');
        submitIcon.click();
      }
    });
  },
  countDown: function(){
    if($(".listTiempo").length){
      $('[data-countdown]').each(function () {
        var $this = $(this), finalDate = $(this).data('countdown');
        $this.countdown(finalDate, function (event) {
            $this = $(this).html(event.strftime(''
            + '<div><span class="datos-tiempo">%D</span><em>Días</em></div><span>:</span>'
            + '<div><span class="datos-tiempo">%H</span><em>Horas</em></div><span>:</span>'
            + '<div><span class="datos-tiempo">%M</span><em>Min</em></div><span>:</span>'
            + '<div><span class="datos-tiempo">%S</span><em>Seg</em></div>'
            ));
        });
      });
    }
  },
  sliderCategory: function(){
    if($(".slider-category").length){
      $('.slider-category').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3000,
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          }
        ]
      });
    }
  },
  sliderGallery: function(){
    if($(".gallery-event").length){
      $('.gallery-event').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
    }
  },
  mapMarket: function(){
    if($(".map-canvas").length){
      $(".mapShow").click(function(e){
        e.preventDefault();
        $(".mapShow").remove();
        $(".map-canvas").addClass("map-show");
        var lat = $(".map-canvas").data("lat");
        var log = $(".map-canvas").data("lon");
        var direc = $(".map-canvas").data("direc");

        var map = new google.maps.Map($('.map-canvas')[0], {
            zoom: 16,
            center: new google.maps.LatLng(lat,log)
        });
        var marker = new google.maps.Marker({
            map: map,
            position: new google.maps.LatLng(lat,log)
        });
        var info = new SnazzyInfoWindow({
            marker: marker,
            closeOnMapClick: false,
            content: direc
        });
        info.open();
      });
    }
  },
  sidebarStickitCustom: function(){
    if($('.sidebar-stickit-custom').length){
      $('.sidebar-stickit-custom').stickit({
        screenMinWidth: 992,
        top: 60
      });
    } 
    if($('.cnt-pay-block').length){
      $('.cnt-pay-block').stickit({
        screenMinWidth: 992,
        top: 60
      });
    } 
  },
  toggleUserCourse: function(e){
    if($(".info-text-autor").hasClass("toggle-active")){
      $(".toggle-click").removeClass("a-toggle");
      $(".info-text-autor").removeClass("toggle-active");
    }else{
      $(".toggle-click").addClass("a-toggle");
      $(".info-text-autor").addClass("toggle-active");
    }
  },
  quantityNum: function(){
    if($('.quantity').length){
      $('.add-l').click(function () {
        var dataMax = $(this).data('max');
        if ($(this).prev().val() < dataMax) {
          $(this).prev().val(+$(this).prev().val() + 1);
        }
      });
      $('.sub-l').click(function () {
        if ($(this).next().val() > 1) {
          if ($(this).next().val() > 1) $(this).next().val(+$(this).next().val() - 1);
        }
      });
    }
  },
  audioMultiPlayer: function(){
    var currentlyPlaying = false;
    function uniqid (prefix, more_entropy) {
      // +   original by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
      // +    revised by: Kankrelune (http://www.webfaktory.info/)
      // %        note 1: Uses an internal counter (in php_js global) to avoid collision
      // *     example 1: uniqid();
      // *     returns 1: 'a30285b160c14'
      // *     example 2: uniqid('foo');
      // *     returns 2: 'fooa30285b1cd361'
      // *     example 3: uniqid('bar', true);
      // *     returns 3: 'bara20285b23dfd1.31879087'
      if (typeof prefix === 'undefined') {
        prefix = "";
      }

      var retId;
      var formatSeed = function (seed, reqWidth) {
        seed = parseInt(seed, 10).toString(16); // to hex str
        if (reqWidth < seed.length) { // so long we split
          return seed.slice(seed.length - reqWidth);
        }
        if (reqWidth > seed.length) { // so short we pad
          return Array(1 + (reqWidth - seed.length)).join('0') + seed;
        }
        return seed;
      };

      // BEGIN REDUNDANT
      if (!this.php_js) {
        this.php_js = {};
      }
      // END REDUNDANT
      if (!this.php_js.uniqidSeed) { // init seed with big random int
        this.php_js.uniqidSeed = Math.floor(Math.random() * 0x75bcd15);
      }
      this.php_js.uniqidSeed++;

      retId = prefix; // start with prefix, add current milliseconds hex string
      retId += formatSeed(parseInt(new Date().getTime() / 1000, 10), 8);
      retId += formatSeed(this.php_js.uniqidSeed, 5); // add seed hex string
      if (more_entropy) {
        // for more entropy we add a float lower to 10
        retId += (Math.random() * 10).toFixed(8).toString();
      }

      return retId;
    }

    $.bboxSoundPlayer = function(options, callback, element) {
        this.element = $(element);
        this.__construct(options, callback);
    }

    $.bboxSoundPlayer.settings = {
        
    }

    $.bboxSoundPlayer.prototype = {
        playlist: [],
        currentPlaylistIndex: 0,
        __construct:function(options, callback) {
            this.options = $.extend(true, {}, $.bboxSoundPlayer.settings, this.element.data(), options);
            
            this.player         = this.element;
            this.playerId       = uniqid('bboxaup_');
            this.playerElement  = $('<div class="gumm-audio-player" id="' + this.playerId + '">');
            this.descriptionEle = this.element.find('.description');
            this.imageEle       = this.element.find('.track-image');
            
            this.setupThePlaylist();
            
            this.player.attr('id', this.playerId + '_controls');

            this.buttonPlay  = this.player.find('a.button-play');
            this.buttonPause = this.player.find('a.button-pause');
            this.playBar     = this.player.find('.track-progress').children('span');
            this.buttonNext  = this.player.find('a.player-button.forward');
            this.buttonPrev  = this.player.find('a.player-button.backward');

            if (this.player.data('playPauseButtonMode') === 'toggle') {
                this.buttonPause = this.buttonPlay.clone();
                this.buttonPause.addClass('button-pause').removeClass('button-play');
                this.buttonPause.find('i').removeClass('fa-play').addClass('fa-pause');
                this.buttonPause.css('display', 'none');
                this.buttonPlay.after(this.buttonPause);

            }

            this.playerElement.data('gummAudioPlayerControls', {
                buttonPause: this.buttonPause,
                buttonPlay: this.buttonPlay,
                container: this.player
            });

            var _self = this;
            this.playerElement.jPlayer({
                ready: function (event) {
                    $(this).jPlayer("setMedia", {
                        mp3: _self.player.data('src')
                    });
                },
                swfPath: './jplayer',
                // supplied: "mp3",
                wmode: "transparent",
                smoothPlayBar: true,
                keyEnabled: true,
                cssSelectorAncestor: '#' + this.playerId + '_controls',
                cssSelector: {
                    seekBar: '.track-progress',
                    mute: '.button-mute',
                    unmute: '.button-unmute',
                    volumeBar: '.volume-bar',
                    volumeBarValue: '.volume-bar > span',
                },
            });
            
            this.bindListeners();
        },
        setupThePlaylist: function() {
            var _self = this;
            var playlistContainer = $(this.element).data('playlistContainer');
            if (playlistContainer !== undefined) {
                playlistContainer = this.element.find(playlistContainer);
                playlistContainer.children().each(function(i, ele) {
                    var _img = $('<img src="' + $(ele).data('imgSrc') +'">');
                    _img.load(function(e){});
                    
                    _self.playlist.push({
                        src: $(ele).data('src'),
                        desc: $(ele).html(),
                        img: _img
                    });
                });
            }
        },
        playNext: function() {
            var nextIndex = this.currentPlaylistIndex + 1;
            
            if (nextIndex >= this.playlist.length) {
                nextIndex = 0;
            }
            
            this.playForPlaylistIndex(nextIndex);
        },
        playPrev: function() {
            var nextIndex = this.currentPlaylistIndex - 1;
            
            if (nextIndex < 0) {
                nextIndex = this.playlist.length - 1;
            }
            
            this.playForPlaylistIndex(nextIndex);
        },
        playForPlaylistIndex: function(index) {
            var playlistItem = this.playlist[index];
            
            this.descriptionEle.html(playlistItem.desc);
            this.imageEle.html(playlistItem.img);
            
            this.currentPlaylistIndex = index;
            
            this.playerElement.jPlayer('clearMedia');
            this.playerElement.jPlayer('setMedia', {
                mp3: playlistItem.src
            });
            
            this.play();
        },
        play: function() {
            if (currentlyPlaying !== false) {
                currentlyPlaying.jPlayer('pause');
                currentlyPlaying.data('gummAudioPlayerControls').buttonPause.hide();
                currentlyPlaying.data('gummAudioPlayerControls').buttonPlay.show();
                currentlyPlaying.data('gummAudioPlayerControls').container.removeClass('current');
            }
            currentlyPlaying = this.playerElement;
            currentlyPlaying.jPlayer('play');

            this.player.addClass('current');
            this.buttonPlay.hide();
            this.buttonPause.show();
        },
        pause: function() {
            currentlyPlaying.jPlayer('pause');

            this.buttonPlay.show();
            this.buttonPause.hide();
        },
        bindListeners: function() {
            var _self = this;
            this.buttonPlay.on('click', function(e){
                e.preventDefault();
                
                _self.play();
            });
            this.buttonPause.on('click', function(e){
                e.preventDefault();

                _self.pause();
            });

            this.playerElement.on($.jPlayer.event.timeupdate, function(e){
                _self.playBar.css({
                    width: e.jPlayer.status.currentPercentAbsolute + '%'
                });
            });

            this.buttonNext.on('click', function(e){
                e.preventDefault();
                
                _self.playNext();
            });
            this.buttonPrev.on('click', function(e){
                e.preventDefault();
                
                _self.playPrev();
            });
        }
    }
    
    $.fn.bboxSoundPlayer = function bboxSoundPlayerFn(options, callback) {
        this.each(function () {
            var instance = $.data(this, 'bboxSoundPlayer');
            if (instance) {
                // update options of current instance
                // instance.update(options);
            } else {
                $.data(this, 'bboxSoundPlayer', new $.bboxSoundPlayer(options, callback, this));
            }

        });
        return this;
    }
    $('.gumm-audio-player').bboxSoundPlayer();
  },
  sliderGallery: function(){
    if($(".inner-gallery-event").length){
      $('.popup-gallery-lead').magnificPopup({
        delegate: 'a',
        type: 'image',
        tLoading: 'Cargando imagen #%curr%...',
        mainClass: 'mfp-img-mobile',
        gallery: {
          enabled: true,
          navigateByImgClick: true,
          preload: [0,1] // Will preload 0 - before current, and 1 after the current image
        },
        image: {
          tError: '',
          titleSrc: function(item) {
            return item.el.attr('title');
          }
        }
      });
    }
  },
  customSelect: function(){
    if($('.block-nivel').length){
      $(".type-nivel").customSelect();
    }
    if($(".type-nivel-c").length){
      $(".type-nivel-c").customSelect({
        placeholder: '<span style="color: #B9B9B9;font-size:14px;">Nivel</span>'
      });  
    }
    if($(".type-modulo-f").length){
      $(".type-modulo-f").customSelect({
        placeholder: '<span style="color: #B9B9B9;font-size:14px;">Módulos</span>'
      });
    }
    if($(".type-nivel-f").length){
      $(".type-nivel-f").customSelect({
        placeholder: '<span style="color: #B9B9B9;font-size:14px;">Niveles</span>'
      });
    }
    if($(".type-week-f").length){
      $(".type-week-f").customSelect({
        placeholder: '<span style="color: #B9B9B9;font-size:14px;">Semanas</span>'
      });
    }
    if($(".type-nivel-a").length){
      $(".type-nivel-a").customSelect({
        placeholder: '<span style="color: #B9B9B9;font-size:14px;">Niveles</span>'
      });  
    }
    if($(".type-mod-a").length){
      $(".type-mod-a").customSelect({
        placeholder: '<span style="color: #B9B9B9;font-size:14px;">Módulos</span>'
      });
    }
    if($(".type-week-a").length){
      $(".type-week-a").customSelect({
        placeholder: '<span style="color: #B9B9B9;font-size:14px;">Semanas</span>'
      });
    }
    if($(".type-p-n").length){
      $(".type-p-n").customSelect({
        placeholder: '<span style="color: #9D9D9D;font-size:14px;">Niveles</span>'
      });
    }
    if($(".type-p-d").length){
      $(".type-p-d").customSelect({
        placeholder: '<span style="color: #9D9D9D;font-size:14px;">Selecciona la duración</span>'
      });
    }
    if($(".type-p-nu").length){
      $(".type-p-nu").customSelect({
        placeholder: '<span style="color: #9D9D9D;font-size:14px;">Selecciona nº</span>'
      });
    }
    if($(".type-p-se").length){
      $(".type-p-se").customSelect({
        placeholder: '<span style="color: #9D9D9D;font-size:14px;">Sesiones dadas</span>'
      });
    }
    if($(".type-p-pro").length){
      $(".type-p-pro").customSelect({
        placeholder: '<span style="color: #9D9D9D;font-size:14px;">Problemáticas</span>'
      });
    }
  },
  centerSlider: function(){
    if($(".center-slider").length){
      $('.center-slider').on('init', function(event, slick){
        var dataSlider = $(".center-slider .slick-slide.slick-current .desc-item-t").html();
        $("#descTeacher").html(dataSlider);
      });

      $('.center-slider').slick({
        centerMode: true,
        centerPadding: '0',
        slidesToShow: 3,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              centerMode: true,
              centerPadding: '100px',
              slidesToShow: 1
            }
          },
          {
            breakpoint: 480,
            settings: {
              centerMode: true,
              centerPadding: '40px',
              slidesToShow: 1
            }
          }
        ]
      });

      $('.center-slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
        var dataSlider = $(".center-slider .slick-slide.slick-current .desc-item-t").html();
        $("#descTeacher").html(dataSlider);
      });

    }
  },
  activeModal: function(){
    if($(".custom-modal-comun").length){
      $('#comunicadoModal').modal('show');
    }
  },
  validateFormIE: function(){
    if($("#idFormCalificaciones").length){

      var validateF = false;
      $('.form-question-one').on('submit', function(e) {
        
        return false;
        /*var check = $(this).find("input[type='checkbox']:checked").length;
        var radio = $(this).find("input[type='radio']:checked").length;
        var input = $(this).find("input[type='text']").val();

        if (check == "") {
            $('.error1').text("Seleccione al menos un checkbox");
            return false;
        } else if (radio == "") {
            $('.error2').text("Seleccione un radio button");
            return false;
        } else if (input == "") {
            $('.error2').text("Seleccione un radio button");
            return false;
        } else {
            $('.errors').hide();
            return true;
        }*/
        /*$(this).find('input[type=text], textarea, input[type=radio]').each(function() {
          if( $(this).val() == "" && $("input[type='radio']:checked").length == '') {
            console.log("Validador de text");
            e.preventDefault();
            $(this).addClass('input-error');
          }else {
            $(this).removeClass('input-error');
          }
        });*/
      });
    }
  },
  tableData: function(){
    $("#tabledata td").click(function (e) {
        e.preventDefault(); // <-- consume event
        e.stopImmediatePropagation();
        
        $this = $(this);

        if ($this.data('editing')) return;  
        
        var val = $this.text();
        
        $this.empty()
        $this.data('editing', true);        
        
        $('<input type="text" class="editfield form-control">').val(val).appendTo($this);
    });

    putOldValueBack = function () {
      $("#tabledata .editfield").each(function(){
        $this = $(this);
        var val = $this.val();
        var td = $this.closest('td');
        td.empty().html(val).data('editing', false);
      });
    }

    $(document).click(function (e) {
      putOldValueBack();
    });
  },
  anclaPreci: function(){
    $('.anclaPreci').click(function(e){        
      e.preventDefault();
      var strAncla=$(this).attr('href');
      $('body,html').stop(true,true).animate({        
        scrollTop: $(strAncla).offset().top - 80
      },1000);
    });
  },
  hourReserv: function(){
    if($(".block-calendar-reserv").length){

       $('#datepickerMent').datepicker({
         language: "es",
         todayHighlight: true
       });

      if($('.footer-calendar-m').length){
        $(".hour-select").customSelect();
      }
      $(".event-resv").click(function(){
         var eventR = $(this);
         eventR.hide();
         eventR.parent("li").find(".resv-btn").show();
      });
    }
  },
  modalImg: function(){
    $('.img-modal').on('click', function() {
      $('.imagepreview').attr('src', $(this).find('img').attr('src'));
      $('#imageModal').modal('show');   
    });
  },
  addCalendar: function(){
    console.log("calendar");
    $(".ace_btn").addcalevent({
      'onclick': true,
      'apps': [0,1,2],
      'data': {
        "title":"new title",
        "desc":"this is a live auction test \n testing new line.", 
        "location": "my house",
        "url": "http://www.ebay.com",    
        "time":{
          "start":"March 11, 2014 14:00:00",
          "end":"march 11, 2014 15:30:00",
          "zone":"-07:00"
        },
      },
      'ics': "http://url to ics generator"
    });
  }
}

jQuery(function($) {
  var requiredCheckboxes = $('.form-question-one').find(':checkbox[required]');
  requiredCheckboxes.on('change', function(e) {
    var checkboxGroup = requiredCheckboxes.filter('[name="' + $(this).attr('name') + '"]');
    var isChecked = checkboxGroup.is(':checked');
    checkboxGroup.prop('required', !isChecked);
  });
  requiredCheckboxes.trigger('change');
});
